import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import {
	useFinishingSocialMediaConnectionType,
	useIsSocialMediaConnectionBusy,
} from '../../../../../queries/Social/useSocialMediaConnectionMutations';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { SettingsSubGroup } from '../../SettingsSubGroup';
import { SocialMediaSettingsServiceConnectionStatus } from './presentation';
import { SocialMediaSignatureComposer } from './SocialMediaSignatureComposer';
import { styleSheet } from './styles';

export const SocialMediaSettings = observer(() => {
	const userSession = useUserSession();
	const connectionsContainerRef = React.useRef<HTMLDivElement>(null);
	const isBusy = useIsSocialMediaConnectionBusy();
	const isFinishing = !!useFinishingSocialMediaConnectionType();

	return (
		<>
			{isFinishing ? (
				<div className={css(styleSheet.finishingNotice)} role='status'>
					<LoadingSpinner type='tiny' />
					<span>Connecting your account…</span>
				</div>
			) : null}
			<SettingsSubGroup title='Connect Social Media Accounts' titleClassName='Social'>
				<div className={css(styleSheet.serviceConnections)} ref={connectionsContainerRef}>
					{Api.SupportedSocialMediaTypes.map(x => (
						<SocialMediaSettingsServiceConnectionStatus
							key={x}
							type={x}
							readOnly={userSession?.account?.features?.socialMedia?.readOnly}
						/>
					))}
				</div>
			</SettingsSubGroup>{' '}
			<SettingsSubGroup
				title='Social Media Signature'
				titleClassName='Social'
				className={css(styleSheet.signatureSubGroup)}
			>
				<SocialMediaSignatureComposer disabled={isBusy} />
			</SettingsSubGroup>
		</>
	);
});
